import React from 'react'

type Props = {
  className?: string
}

const CalendarSchedule: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="24" height="24" rx="4" fill="#F1FBFB" />
    <path
      d="M7.33333 18.6668C6.96667 18.6668 6.65278 18.5363 6.39167 18.2752C6.13056 18.0141 6 17.7002 6 17.3335V8.00016C6 7.6335 6.13056 7.31961 6.39167 7.0585C6.65278 6.79738 6.96667 6.66683 7.33333 6.66683H8V5.3335H9.33333V6.66683H14.6667V5.3335H16V6.66683H16.6667C17.0333 6.66683 17.3472 6.79738 17.6083 7.0585C17.8694 7.31961 18 7.6335 18 8.00016V17.3335C18 17.7002 17.8694 18.0141 17.6083 18.2752C17.3472 18.5363 17.0333 18.6668 16.6667 18.6668H7.33333ZM7.33333 17.3335H16.6667V10.6668H7.33333V17.3335Z"
      fill="#13C1BF"
    />
  </svg>
)

export default CalendarSchedule
